import { ButtonTriggerEvent } from '../../../common/components';
import { HubFeed } from '../../../models/hub/hub.feed';

export class AddCityModalActions {
    confirm: (event: ButtonTriggerEvent, locationFeeds: any) => void;
    cancel?: () => void;
}

export class AddCityModalData {
    public hubName: string;
    public regionId: string;
    public isNoFeeds: boolean;
    public locationFeeds: any;
    constructor(hubName: string, regionId: string, isNoFeeds: boolean, locations: any) {
        this.hubName = hubName;
        this.regionId = regionId;
        this.isNoFeeds = isNoFeeds;
        this.locationFeeds = locations;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/add.city.modal/add.city.modal.provider.ts